tinymce.addI18n("gl", {
    "#": "",
    "Accessibility": "",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Acci\xf3n",
    "Activity": "Actividade",
    "Address": "Enderezo",
    "Advanced": "Avanzado",
    "Align": "Ali\xf1amento",
    "Align center": "Ali\xf1ar ao centro",
    "Align left": "Ali\xf1ar \xe1 esquerda",
    "Align right": "Ali\xf1ar \xe1 dereita",
    "Alignment": "Ali\xf1amento",
    "Alignment {0}": "",
    "All": "Todo",
    "Alternative description": "",
    "Alternative source": "Orixe alternativa",
    "Alternative source URL": "URL da orixe alternativa",
    "Anchor": "",
    "Anchor...": "Ancoraxe...",
    "Anchors": "Ancoraxes",
    "Animals and Nature": "Animais e natureza",
    "Arrows": "Frechas",
    "B": "",
    "Background color": "Cor do fondo",
    "Background color {0}": "",
    "Black": "Negro",
    "Block": "Bloque",
    "Block {0}": "",
    "Blockquote": "Bloque entre comi\xf1as",
    "Blocks": "Bloques",
    "Blue": "Azul",
    "Blue component": "",
    "Body": "Corpo",
    "Bold": "Negra",
    "Border": "Bordo",
    "Border color": "Cor do bordo",
    "Border style": "Estilo do bordo",
    "Border width": "Largo do bordo",
    "Bottom": "Abaixo",
    "Browse files": "",
    "Browse for an image": "Buscar unha imaxe",
    "Browse links": "",
    "Bullet list": "Lista de vi\xf1etas",
    "Cancel": "Cancelar",
    "Caption": "Subt\xedtulo",
    "Cell": "Cela",
    "Cell padding": "Marxe interior da cela",
    "Cell properties": "Propiedades da cela",
    "Cell spacing": "Marxe entre celas",
    "Cell styles": "",
    "Cell type": "Tipo de cela",
    "Center": "Centro",
    "Characters": "Caracteres",
    "Characters (no spaces)": "Caracteres (sen espazos)",
    "Circle": "Circulo",
    "Class": "Clase",
    "Clear formatting": "Limpar o formato",
    "Close": "Pechar",
    "Code": "C\xf3digo",
    "Code sample...": "Mostra de c\xf3digo...",
    "Code view": "",
    "Color Picker": "Selector de cor",
    "Color swatch": "Mostra de cores",
    "Cols": "Cols.",
    "Column": "Columna",
    "Column clipboard actions": "",
    "Column group": "Grupo de columnas",
    "Column header": "",
    "Constrain proportions": "Restrinxir as proporci\xf3ns",
    "Copy": "Copiar",
    "Copy column": "",
    "Copy row": "Copiar fila",
    "Could not find the specified string.": "Non foi pos\xedbel atopar a cadea de texto especificada.",
    "Could not load emojis": "",
    "Count": "",
    "Currency": "Moeda",
    "Current window": "Xanela actual",
    "Custom color": "Cor personalizado",
    "Custom...": "Personalizado...",
    "Cut": "Cortar",
    "Cut column": "",
    "Cut row": "Cortar fila",
    "Dark Blue": "",
    "Dark Gray": "Gris escuro",
    "Dark Green": "Verde escuro",
    "Dark Orange": "Laranxa escuro",
    "Dark Purple": "",
    "Dark Red": "Vermello escuro",
    "Dark Turquoise": "Turquesa escuro",
    "Dark Yellow": "Amarelo escuro",
    "Dashed": "",
    "Date/time": "Data/hora",
    "Decrease indent": "Reducir a sangr\xeda",
    "Default": "Predeterminada",
    "Delete accordion": "",
    "Delete column": "Eliminar columna",
    "Delete row": "Eliminar fila",
    "Delete table": "Eliminar t\xe1boa",
    "Dimensions": "Dimensi\xf3ns",
    "Disc": "Disco",
    "Div": "",
    "Document": "",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "Soltar unha imaxe",
    "Dropped file type is not supported": "",
    "Edit": "Editar",
    "Embed": "Integrado",
    "Emojis": "",
    "Emojis...": "Emoticonas...",
    "Error": "Erro",
    "Error: Form submit field collision.": "Erro: conflito de campo ao enviar o formulario ",
    "Error: No form element found.": "Erro: non se atopou ning\xfan elemento de formulario",
    "Extended Latin": "Latino extendido",
    "Failed to initialize plugin: {0}": "Produciuse un fallo ao iniciar o engadido: {0}",
    "Failed to load plugin url: {0}": "Produciuse un fallo ao cargar a o URL do engadido: {0}",
    "Failed to load plugin: {0} from url {1}": "Produciuse un fallo ao cargar a o engadido: {0} dende o URL {1}",
    "Failed to upload image: {0}": "Produciuse un fallo ao cargar a imaxe: {0}",
    "File": "Ficheiro",
    "Find": "Buscar",
    "Find (if searchreplace plugin activated)": "Atopar (se o engadido para buscar e substitu\xedr estiver activado) ",
    "Find and Replace": "",
    "Find and replace...": "Atopar e substitu\xedr...",
    "Find in selection": "",
    "Find whole words only": "Atopar unicamente as palabras enteiras",
    "Flags": "Bandeiras",
    "Focus to contextual toolbar": "Foco na barra de ferramentas de contexto",
    "Focus to element path": "Foco na ruta do elemento",
    "Focus to menubar": "Foco na barra de menu",
    "Focus to toolbar": "Foco na barra de ferramentas",
    "Font": "",
    "Font size {0}": "",
    "Font sizes": "",
    "Font {0}": "",
    "Fonts": "Tipos de letra",
    "Food and Drink": "Comida e bebida",
    "Footer": "Rodap\xe9",
    "Format": "Formato",
    "Format {0}": "",
    "Formats": "Formatos",
    "Fullscreen": "Pantalla completa",
    "G": "",
    "General": "Xeral",
    "Gray": "Gris",
    "Green": "Verde",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Atallos \xfatiles",
    "Header": "Cabeceira",
    "Header cell": "Cela de cabeceira",
    "Heading 1": "T\xedtulo 1",
    "Heading 2": "T\xedtulo 2",
    "Heading 3": "T\xedtulo 3",
    "Heading 4": "T\xedtulo 4",
    "Heading 5": "T\xedtulo 5",
    "Heading 6": "T\xedtulo 6",
    "Headings": "T\xedtulo",
    "Height": "Alto",
    "Help": "Axuda",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "Li\xf1a horizontal",
    "Horizontal space": "Espazo horizontal",
    "ID": "",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "Image is decorative": "",
    "Image list": "Lista de imaxes",
    "Image title": "T\xedtulo da imaxe",
    "Image...": "Imaxe...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Aumentar a sangr\xeda",
    "Inline": "En li\xf1a",
    "Insert": "Inserir",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Inserir columna \xe1 dereita",
    "Insert column before": "Inserir columna \xe1 esquerda",
    "Insert date/time": "Inserir data/hora",
    "Insert image": "Inserir imaxe",
    "Insert link (if link plugin activated)": "Inserir a ligaz\xf3n (se o engadido de ligaz\xf3ns estiver activado) ",
    "Insert row after": "Inserir unha fila embaixo",
    "Insert row before": "Inserir unha fila enriba",
    "Insert table": "Inserir t\xe1boa",
    "Insert template...": "Inserir modelo...",
    "Insert video": "Inserir v\xeddeo",
    "Insert/Edit code sample": "Inserir/editar mostra de c\xf3digo",
    "Insert/edit image": "Inserir/editar imaxe",
    "Insert/edit link": "Inserir/editar ligaz\xf3n",
    "Insert/edit media": "Inserir/editar medios",
    "Insert/edit video": "Inserir/editar v\xeddeo",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Cursiva",
    "Justify": "Xustificar",
    "Keyboard Navigation": "",
    "Language": "Idioma",
    "Learn more...": "Saiba m\xe1is...",
    "Left": "Esquerda",
    "Left to right": "De esquerda a dereita",
    "Light Blue": "",
    "Light Gray": "Gris claro",
    "Light Green": "",
    "Light Purple": "",
    "Light Red": "",
    "Light Yellow": "",
    "Line height": "",
    "Link list": "Lista de ligaz\xf3ns",
    "Link...": "Ligaz\xf3n...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "Alfa min\xfascula",
    "Lower Greek": "Grega min\xfascula",
    "Lower Roman": "Romana min\xfascula",
    "Match case": "Distinguir mai\xfasculas",
    "Mathematical": "Matem\xe1tico",
    "Media poster (Image URL)": "Cartel multimedia (URL da imaxe)",
    "Media...": "Multimedia...",
    "Medium Blue": "Azul medio",
    "Medium Gray": "Gris medio",
    "Medium Purple": "P\xfarpura medio",
    "Merge cells": "Combinar celas",
    "Middle": "Medio",
    "Midnight Blue": "Azul noite",
    "More...": "",
    "Name": "Nome",
    "Navy Blue": "Azul mari\xf1o",
    "New document": "Novo documento",
    "New window": "Nova xanela",
    "Next": "Seguinte",
    "No": "",
    "No alignment": "",
    "No color": "Sen cor",
    "Nonbreaking space": "Espazo irromp\xedbel",
    "None": "Ning\xfan",
    "Numbered list": "Lista numerada",
    "OR": "OU",
    "Objects": "Obxectos",
    "Ok": "Aceptar",
    "Open help dialog": "Abrir o di\xe1logo de axuda",
    "Open link": "",
    "Open link in...": "Abrir a ligaz\xf3n en...",
    "Open popup menu for split buttons": "",
    "Orange": "Laranxa",
    "Outset": "Exterior",
    "Page break": "Quebra de p\xe1xina",
    "Paragraph": "Par\xe1grafo",
    "Paste": "Pegar",
    "Paste as text": "Pegar como texto",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Neste momento o pegado est\xe1 definido en modo de texto simple. Os contidos pegaranse como texto sen formato ata que se active esta opci\xf3n.",
    "Paste or type a link": "Pegue ou escriba unha ligaz\xf3n",
    "Paste row after": "Pegar fila enriba",
    "Paste row before": "Pegar fila embaixo",
    "Paste your embed code below:": "Pegue embaixo o c\xf3digo integrado:",
    "People": "Xente",
    "Plugins": "Engadidos",
    "Plugins installed ({0}):": "Engadidos instalados ({0}):",
    "Powered by {0}": "Coa tecnolox\xeda de {0}",
    "Pre": "",
    "Preferences": "",
    "Preformatted": "Preformatado",
    "Premium plugins:": "Engadidos comerciais:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Vista previa",
    "Previous": "Anterior",
    "Print": "",
    "Print...": "Imprimir...",
    "Purple": "P\xfarpura",
    "Quotations": "Citas",
    "R": "",
    "Range 0 to 255": "",
    "Red": "Vermello",
    "Red component": "",
    "Redo": "Refacer",
    "Remove": "",
    "Remove color": "Retirar a cor",
    "Remove link": "Retirar a ligaz\xf3n",
    "Replace": "Substitu\xedr",
    "Replace all": "Substitu\xedr todo",
    "Replace with": "Substitu\xedr con",
    "Resize": "Redimensionar",
    "Restore last draft": "Restaurar o \xfaltimo borrador",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "\xc1rea de texto mellorado. PremaALT-0 para obter axuda.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\xc1rea de texto mellorado. Prema ALT-F9 para o men\xfa. Prema ALT-F10 para a barra de ferramentas. Prema ALT-0 para a axuda",
    "Ridge": "",
    "Right": "Dereita",
    "Right to left": "De dereita a esquerda",
    "Row": "Fila",
    "Row clipboard actions": "",
    "Row group": "Grupo de filas",
    "Row header": "",
    "Row properties": "Propiedades das filas",
    "Row type": "Tipo de fila",
    "Rows": "Filas",
    "Save": "Gardar",
    "Save (if save plugin activated)": "Gardar (se o engadido para gardar estiver activado) ",
    "Scope": "\xc1mbito",
    "Search": "Buscar",
    "Select all": "Seleccionar todo",
    "Select...": "",
    "Selection": "",
    "Shortcut": "Atallo",
    "Show blocks": "Amosar os bloques",
    "Show caption": "Amosar subt\xedtulo",
    "Show invisible characters": "Amosar caracteres invis\xedbeis",
    "Size": "",
    "Solid": "",
    "Source": "Orixe",
    "Source code": "C\xf3digo fonte",
    "Special Character": "",
    "Special character...": "",
    "Split cell": "Dividir celas",
    "Square": "Cadrado",
    "Start list at number": "",
    "Strikethrough": "Riscado",
    "Style": "Estilo",
    "Subscript": "Sub\xedndice",
    "Superscript": "Super\xedndice",
    "Switch to or from fullscreen mode": "Activar ou desactivar o modo de pantalla completa",
    "Symbols": "S\xedmbolos",
    "System Font": "Tipo de letra do sistema",
    "Table": "T\xe1boa",
    "Table caption": "",
    "Table properties": "Propiedades da t\xe1boa",
    "Table styles": "",
    "Template": "Modelo",
    "Templates": "Modelos",
    "Text": "Texto",
    "Text color": "Cor do texto",
    "Text color {0}": "",
    "Text to display": "Texto que amosar",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "O URL que introduciu semella ser un enderezo de correo. Quere engadirlle o prefixo mailto: requirido?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "O URL que introduciu semella ser unha ligaz\xf3n externa. Quere engadirlle o prefixo http:// requirido?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "",
    "Title": "T\xedtulo",
    "To open the popup, press Shift+Enter": "Para abrir a xanela emerxente, prema Mai\xfas+Intro",
    "Toggle accordion": "",
    "Tools": "Ferramentas",
    "Top": "Arriba",
    "Travel and Places": "Viaxes e lugares",
    "Turquoise": "Turquesa",
    "Underline": "Subli\xf1ado",
    "Undo": "Desfacer",
    "Upload": "Cargar",
    "Uploading image": "",
    "Upper Alpha": "Alfa mai\xfascula",
    "Upper Roman": "Romana mai\xfascula",
    "Url": "URL",
    "User Defined": "Definido polo usuario",
    "Valid": "V\xe1lido",
    "Version": "",
    "Vertical align": "",
    "Vertical space": "Espazo vertical",
    "View": "Ver",
    "Visual aids": "Axudas visuais",
    "Warn": "Aviso",
    "White": "Branco",
    "Width": "Largo",
    "Word count": "Reconto de palabras",
    "Words": "",
    "Words: {0}": "Palabras: {0}",
    "Yellow": "Amarelo",
    "Yes": "",
    "You are using {0}": "Est\xe1 a empregar {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Ten cambios sen gardar. Confirma que quere sa\xedr?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "O seu navegador non admite o acceso directo ao portapapeis. Empregue os atallos de teclado Ctrl+X/C/V no seu canto.",
    "alignment": "ali\xf1amento",
    "austral sign": "S\xedmbolo do austral",
    "cedi sign": "S\xedmbolo do cedi",
    "colon sign": "S\xedmbolo do col\xf3n",
    "cruzeiro sign": "S\xedmbolo do cruzeiro",
    "currency sign": "S\xedmbolo de moeda",
    "dollar sign": "S\xedmbolo do dolar",
    "dong sign": "S\xedmbolo do dong",
    "drachma sign": "S\xedmbolo do dracma",
    "euro-currency sign": "S\xedmbolo do euro",
    "example": "exemplo",
    "formatting": "formatado",
    "french franc sign": "S\xedmbolo do franco franc\xe9s",
    "german penny symbol": "S\xedmbolo do penique alem\xe1n",
    "guarani sign": "S\xedmbolo do guaran\xed",
    "history": "historial",
    "hryvnia sign": "S\xedmbolo do grivna",
    "indentation": "sangrado",
    "indian rupee sign": "S\xedmbolo da rupia india",
    "kip sign": "S\xedmbolo do kip",
    "lira sign": "S\xedmbolo da lira",
    "livre tournois sign": "S\xedmbolo da libre tournois",
    "manat sign": "S\xedmbolo do manat",
    "mill sign": "S\xedmbolo do mill",
    "naira sign": "S\xedmbolo da naira",
    "new sheqel sign": "S\xedmbolo do novo s\xe9quel",
    "nordic mark sign": "S\xedmbolo do marco n\xf3rdico",
    "peseta sign": "S\xedmbolo da peseta",
    "peso sign": "S\xedmbolo do peso",
    "ruble sign": "S\xedmbolo do rublo",
    "rupee sign": "S\xedmbolo da rupia",
    "spesmilo sign": "S\xedmbolo do spesmilo",
    "styles": "estilos",
    "tenge sign": "S\xedmbolo do tengue",
    "tugrik sign": "S\xedmbolo do tugrik",
    "turkish lira sign": "S\xedmbolo da lira turca",
    "won sign": "S\xedmbolo do won",
    "yen character": "Car\xe1cter do ien",
    "yen/yuan character variant one": "Variante  1 do car\xe1cter do ien/yuan",
    "yuan character": "Car\xe1cter do yuan",
    "yuan character, in hong kong and taiwan": "Car\xe1cter do yuan, en Hong Kong e Taiwan",
    "{0} characters": "",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} palabras"
});